class LyleUspIcons extends HTMLElement {
  #loadMoreButton = null;

  connectedCallback() {
    this.#loadMoreButton = this.querySelector(".usp-icons__load-more");

    if (!this.#loadMoreButton) return;

    this.#syncExpandedState();
    this.#loadMoreButton.addEventListener("click", this.#handleLoadMoreClick);
  }

  disconnectedCallback() {
    this.#loadMoreButton?.removeEventListener(
      "click",
      this.#handleLoadMoreClick,
    );
    this.#loadMoreButton = null;
  }

  #handleLoadMoreClick = () => {
    this.classList.toggle("is-collapsed");
    this.#syncExpandedState();
  };

  #syncExpandedState() {
    const expanded = !this.classList.contains("is-collapsed");
    this.#loadMoreButton?.setAttribute("aria-expanded", String(expanded));
  }
}

if (!customElements.get("lyle-usp-icons")) {
  customElements.define("lyle-usp-icons", LyleUspIcons);
}
